package game.controller

import com.soywiz.korev.GameButton
import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import game.CgaColor
import game.Game
import view.Terminal

class DialogController : GameController() {
    var message = ""
    var pressed = false
    var released = false
    var dialogTimer = 0
    val timeout = 100

    override fun onTick(game: Game, input: Input) {
        if (input.mouseButtons == 0) {
            released = true
        }
        if (released && input.mouseButtons != 0) {
            pressed = true
        }

        val buttonPressed = if (input.gamepads.isNotEmpty()) {
            input.gamepads[0][GameButton.BUTTON0] > 0.5 ||
            input.gamepads[0][GameButton.BUTTON1] > 0.5 ||
            input.gamepads[0][GameButton.BUTTON2] > 0.5 ||
            input.gamepads[0][GameButton.BUTTON3] > 0.5
        } else {
            false
        }

        if ((input.mouseButtons == 0 && pressed) // HACK: input.click does not seem to work :P
            || input.keys.justReleased(Key.ENTER)
            || input.keys.justReleased(Key.KP_ENTER)
            || input.keys.justReleased(Key.SPACE)
            || buttonPressed
        ) {
            if (dialogTimer >= timeout) {
                game.controller = nextController
            }
        }

        dialogTimer++
    }

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderAll(terminal)

        val startCol = 14
        val endCol = 65
        val startRow = 5
        val endRow = 19

        terminal.fillRect(startCol, startRow, endCol, endRow, 32, CgaColor.WHITE, CgaColor.LIGHT_BLUE)
        terminal.drawDoubleBorder(
            startCol - 1,
            startRow - 1,
            endCol + 1,
            endRow + 1,
            CgaColor.YELLOW,
            CgaColor.LIGHT_BLUE
        )

        terminal.drawText(
            message,
            startCol + 2,
            startRow + 1,
            endCol, 2,
            CgaColor.YELLOW,
            CgaColor.LIGHT_BLUE
        )

        if (dialogTimer >= timeout) {
            terminal.drawString(
                startCol + 2,
                endRow - 1,
                game.text("Dialog_CloseMessage"),
                CgaColor.LIGHT_GRAY,
                CgaColor.LIGHT_BLUE
            )
        }
    }
}
